import { render, staticRenderFns } from "./CoralsolLocalidade.vue?vue&type=template&id=5262fb68&"
import script from "./CoralsolLocalidade.vue?vue&type=script&lang=js&"
export * from "./CoralsolLocalidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports